<template>
  <div :style="tagStyle">
    <span :style="`font-size: ${tag.description_font_size}pt`">
      {{ product.description }}
    </span>

    <div :style="priceStyle">
      <template v-if="enabledPolicePrice">
        <span v-if="tag.show_price_immediate">
          P. Vista {{ product.price_payment_immediate }}
        </span>

        <span v-if="tag.show_price_on_terms">
          P. Prazo {{ product.price_payment_on_terms }}
        </span>
      </template>

      <span v-if="!enabledPolicePrice"> Por R$ {{ product.price }} </span>
    </div>

    <template v-if="tag.show_barcode">
      <VueBarcode
        id="barcodegen"
        :height="barCodeStyle.height"
        :fontSize="tag.price_font_size"
        :text="product.base_sku_id"
        :value="product.base_sku_id"
      />
    </template>
  </div>
</template>

<script>
import VueBarcode from "vue-barcode";

export default {
  components: {
    VueBarcode
  },
  props: {
    product: {},
    tag: {
      default: () => {
        return {
          height: 10,
          width: 7,
          padding: 2,
          margin: 2,
          price_font_size: 7,
          description_font_size: 8,
          show_barcode: true,
          show_price_immediate: true,
          show_price_on_terms: true
        };
      }
    }
  },

  computed: {
    enabledPolicePrice() {
      if (this.$store.state.company.product_payment_policy == 2) {
        return true;
      }
    },
    tagStyle() {
      return {
        width: `${this.tag.width}mm`,
        height: `${this.tag.height}mm`,
        padding: `${this.tag.padding}mm`,
        margin: `${this.tag.margin}mm`,

        display: "flex",
        "text-align": "center",
        "align-items": "center",
        "justify-content": "center",
        "flex-direction": "column",
        border: "1px solid black"
      };
    },

    priceStyle() {
      return {
        "font-size": `${this.tag.price_font_size}pt`,
        display: "flex",
        width: "70%",
        "justify-content": "center",
        "align-items": "center",
        "text-align": "center"
      };
    },

    barCodeStyle() {
      return {
        height: `${this.tag.height * 0.6}`
      };
    }
    // height() {
    //   return this.tag.height * 10;
    // },
    // width() {
    //   return this.tag.width * 10;
    // },
    // padding() {
    //   return this.tag.padding * 10;
    // },
    // margin() {
    //   return this.tag.margin * 10;
    // }
  }
};
</script>

<style lang="scss">
#tag {
  border: 0.5px solid black;

  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    //o texto não pode sair do container
  }

  #barcodegen {
    // width: 90%;
    height: 60%;
  }
}
</style>
